<template>
  <div class="gou-upload" @click.stop="()=>pickFile()">
    <slot>
      <div class="gou-upload-logo">
        <i class="iconfont icon-icon_add" />
        <span>点击添加</span>
        <div v-if="address" class="image-layer">
          <img :src="address">
        </div>
      </div>
    </slot>
  </div>
</template>
<script>
export default {
  props: {
    filters: {
      type: String,
      default: ''
    },
    multiple: {
      type: Boolean,
      default: true
    },
    maxFileSize: { // MB
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      address: ''
    }
  },
  methods: {
    async pickFile(file) {
      if (file === undefined) {
        file = await this.$file.pickFile({
          filters: this.filters,
          multiple: this.multiple
        })
        await this.pickFile(file)
      } else {
        if (this.multiple) {
          for (let i = 0; i < file.length; i++) {
            const size = Math.floor(file[i].size / 1024 / 1024 * 100) / 100
            if (this.maxFileSize > 0 && size > this.maxFileSize) {
              this.$layer.msg(`文件大小超过限制，请重新上传`, { time: 3000 })
              return
            }
          }
        } else {
          const size = Math.floor(file.size / 1024 / 1024 * 100) / 100
          if (this.maxFileSize > 0 && size > this.maxFileSize) {
            this.$layer.msg(`文件大小超过限制，请重新上传`, { time: 3000 })
            return
          }
        }
        this.$emit('event-pick-file', { file })
      }
    },
  },
}
</script>
<style lang="less" scoped>
  .gou-upload{
    display:flex;
    /*place-items: flex-end;*/
    cursor: pointer;

    .image-layer{
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      border: 0;
      height: 100%;
      background: #D5EFF4;
      text-align: center;
      display: flex;
      justify-content: center;
      opacity: 0.5;
    }
    .gou-upload-logo{
      position: relative;
      cursor: pointer;
      width: 176px;
      height: 96px;
      background-color: #D5EFF4;
      display: flex;
      flex-flow: column;
      align-items: center;
      justify-content: center;
      span{
        line-height: 10px;
        margin-top: 10px;
      }

      .icon-icon_add{
        font-size: 12px;
        &::before{
          border: 2px solid rgba(76, 84, 114, 1);
          border-radius: 50%;
          padding: 2px;
        }
      }
    }
    .gou-upload-tips{
      margin-left: 16px;
    }
  }
</style>
